<template>
<div :style="columnMargin" class="slide-prod">
  
  <div @click="toProdDetail(prodItem)" class="prod-one" v-for="(prodItem, prodIndex) in item.prodList" :key="prodIndex">
    <img class="prod-img" :src="prodItem.imgUrl" alt="">
    <div class="prod-price-bar">
      <div class="flex-1 col-1"><span style="color:#F72D17">¥<span class="prod-price">{{prodItem.prodPrice}}</span></span><span v-if='0' class="prod-old-price">{{prodItem.originPrice}}</span></div>
      <div @click.stop="addShopCart(prodItem)" class="prod-cart"></div>
    </div>
    <div v-if="prodItem.originPrice && prodItem.originPrice.length>1 && Number(prodItem.originPrice.replace('¥','')) > Number(prodItem.prodPrice)" class="prod-old-price marginL-paddingB-7">¥{{prodItem.originPrice.replace('¥','')}}</div>
  </div>
</div>
</template>

<script>
import axios from 'axios';
export default { 
  name: 'SlideProd',
  data() {
    return {
      active: 0,
      addShopCartLock: {}
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    toProdDetail(obj){
      var self = this
      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      obj.prodUrl && (url = obj.prodUrl);
      this.$store.commit('doTrack',{
        href: url,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.prodId,
        adName: obj.prodName,
        idType: 'prodId'
      });
      window.location.href = url
    },
    addShopCart(obj){
      var self = this
      if(self.addShopCartLock[obj.prodId]){
        return
      }
      var fqzxStatus = obj.productLabels && obj.productLabels.length && obj.productLabels.findIndex(o=>o.key=='FQZX') > -1;
      if(obj.isSku && obj.isSku == '0' && !fqzxStatus){
        var params = {
          "addTime": new Date().getTime(),
          "shopCar.productId": obj.prodId,
          "shopCar.productName": obj.name,
          "shopCar.productAmt": 1,
          "shopCar.productImage": obj.imgUrl,
          "shopCar.productPrice": obj.prodPrice,
          "shopCar.productType": '0',
          "shopCar.channelType": '1',
          "shopCar.buyDelivery": '01',
          "shopCar.payMode": obj.paymentId + '_null',
          "shopCar.merchantId": obj.merchantId,
          "shopCar.productCategoryId": obj.catId
        }
        self.addShopCartLock[obj.prodId] = true
        axios.get('/shoppingcart/addShopCarJS.jhtml', { params: params }).then(function(res){
          self.addShopCartLock[obj.prodId] = false
          if (res.data.resultCode == "0") {
            self.$store.commit('setPublicToast',{
              show: true,
              type: 'addShopcart',
              text: '添加成功，在购物车等亲~'
            });
            clientTools.updateBottomNavShopcarSum()
            // self.$toast('添加购物车成功');
          } else {
            self.$toast(res.data.msg);
          }
        })
        return
      }

      var url = '/client/cpd_' + obj.prodId + '.jhtml'
      obj.prodUrl && (url = obj.prodUrl);
      window.location.href = url
    }  
  }
}
</script>

<style scoped>
.slide-prod{
  margin-top: 10px;
  margin-left: 15px;
  width: 345px;
  /* height: 117px; */
  display: flex;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.slide-prod::-webkit-scrollbar{
  width: 0px !important;
  height: 0px !important;
  background-color: unset !important
}
.prod-one{
  flex-basis: 112px;
  flex-shrink: 0;
  white-space: nowrap;
  /* height: 100%; */
  border-radius: 6px;
  background: #fff;
  margin-left: 4px
}
.prod-one:first-child{
  margin-left: 0
}
.prod-img{
  width: 112px;
  height: 92px;
  border-radius: 6px;
  display: block;
  object-fit: contain
}
.prod-price-bar{
  height: 25px;
  padding: 0 7px;
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #999;
}
.prod-price{
  margin-left: 0.5px;
  font-size: 14px
}
.prod-old-price{
  color: #999;
  text-decoration: line-through;
  font-size: 10px;
  margin-left: 2px
}
.marginL-paddingB-7{
  margin-left: 7px;
  padding-bottom: 7px;
}
.prod-cart{
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #FFF4F4 url(./assets/cart_icon.png) no-repeat center;
  background-size: 100%
}
</style>